import http from '@/utils/http'
import httpApi from '@/apis/httpApi'

// 获取网吧分组列表
export const getBarGroupList = () => {
  return new Promise((resolve) => {
    resolve(
      http.usualPost({
        url: httpApi.bar.getGroupList,
      })
    )
  })
}

// 获取最近远程数
export const getRecentRemoteNum = () => {
  return http.usualPost({
    url: httpApi.bar.getRemoteNum,
    data: {
      type: 1,
    },
  })
}
// 获取协助远程数
export const getAssistRemoteNum = () => {
  return http.usualPost({
    url: httpApi.bar.getRemoteNum,
    data: {
      type: 2,
    },
  })
}

// 获取服务器离线的网吧数
export const getServerOfflineBarNum = () => {
  return http.usualPost({
    url: httpApi.bar.getServerOfflineBarNum,
  })
}

// 获取网吧列表
export const getBarList = ({ pageNum, pageSize, groupId, searchTxt, flag }) => {
  return http.usualPost({
    url: httpApi.bar.getBarList,
    data: {
      pageNum,
      pageSize,
      groupId: groupId === undefined ? '' : groupId,
      searchTxt: searchTxt === undefined ? '' : searchTxt,
      flag: flag === undefined ? '' : flag,
    },
  })
}
// 获取全部网吧
export const getAllBarList = ({ groupId }) => {
  return http.usualPost({
    url: httpApi.bar.getAllBarList,
    data: {
      groupId,
    },
  })
}
// 获取最近远程的服务器列表
export const getServerList = ({ type, page, pageSize }) => {
  return http.usualPost({
    url: httpApi.bar.getRemoteServerList,
    data: {
      type,
      page,
      pageSize,
    },
  })
}
// 删除远程协助记录
export const delRemoteRecord = (barRemoteHistoryId) => {
  return http.post({
    url: httpApi.bar.delRemoteRecord,
    data: {
      barRemoteHistoryId,
    },
  })
}
// 获取网吧下的服务器列表
export const getBarServerList = ({ barId }) => {
  return http.usualPost({
    url: httpApi.bar.getBarServerList,
    data: {
      barId,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 获取网吧下的路由列表
export const getBarRouteList = ({ barId }) => {
  return http.usualPost({
    url: httpApi.bar.getBarRouteList,
    data: {
      barId,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 获取网吧下的客户机列表
export const getBarClientList = ({ barId, pageNum, pageSize }) => {
  return http.usualPost({
    url: httpApi.bar.getBarClientList,
    data: {
      barId,
      pageNum,
      pageSize,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 获取bs自动登录信息
export const getAutoLoginInfo = ({ barId, flag }) => {
  return http.usualPost({
    url: httpApi.bar.getAutoLoginInfo,
    data: {
      barId,
      flag,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 更新bs自动登录信息
export const updateBsAutoLoginInfo = ({
  barId,
  flag,
  autoLogin,
  loginName,
  password,
}) => {
  return http.usualPost({
    url: httpApi.bar.updateBsAutoLoginInfo,
    data: {
      barId,
      flag,
      autoLogin,
      loginName,
      password,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 路由登录
export const routeAutoLogin = ({ routerId }) => {
  return http.msgPost({
    url: httpApi.bar.routeAutoLogin,
    data: {
      routerId,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 获取直连模式和备用远程信息
export const getBarRemoteInfo = ({ barId }) => {
  return http.usualPost({
    url: httpApi.bar.getBarRemoteInfo,
    data: {
      barId,
    },
  })
}
// 设置直连模式和备用远程
export const updateBarRemoteInfo = ({
  barId,
  autoType,
  wanip,
  vport,
  pport,
  mstscSwitch,
}) => {
  return http.post({
    url: httpApi.bar.updateBarRemoteInfo,
    data: {
      barId,
      autoType,
      wanip,
      vport,
      pport,
      mstscSwitch,
    },
  })
}
// 远程
export const barToRemote = ({ barId, flag, isServer, control }) => {
  return http.post({
    url: httpApi.bar.toRemote,
    data: {
      barId,
      flag,
      isServer,
      control,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 远程cmd
export const toRemoteCmd = ({ barId, type, flag }) => {
  return http.msgPost({
    url: httpApi.bar.toRemoteCmd,
    data: {
      barId,
      type,
      flag,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 获取品牌列表
export const queryTradeMarkList = () => {
  return http.usualPost({
    url: httpApi.bar.queryTradeMarkList,
    data: {},
  })
}
// 获取城市
export const getCity = (ip) => {
  return http.get({
    url: 'https://ip.useragentinfo.com/json',
    data: {
      ip: ip,
    },
  })
}
// 发送远程命令行
export const sendRemoteCommand = (
  { barId, flag },
  isServer,
  command,
  control
) => {
  return http.post({
    url: httpApi.bar.sendRemoteCommand,
    data: {
      barId,
      flag,
      isServer,
      command,
      control: control === undefined ? '' : control,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 添加路由器
export const addRouter = ({
  barId,
  tradeMark,
  autoGetIP,
  scheme,
  ip,
  port,
  routerPassAccount,
  routerPassPwd,
  remark,
}) => {
  return http.post({
    url: httpApi.bar.addRouter,
    data: {
      barId,
      tradeMark,
      autoGetIP,
      scheme,
      ip,
      port,
      routerPassAccount,
      routerPassPwd,
      remark,
    },
  })
}
// 修改路由
export const updateRouter = ({
  routerId,
  barId,
  tradeMark,
  autoGetIP,
  scheme,
  ip,
  port,
  routerPassAccount,
  routerPassPwd,
  remark,
}) => {
  return http.post({
    url: httpApi.bar.updateRouter,
    data: {
      routerId,
      barId,
      tradeMark,
      autoGetIP,
      scheme,
      ip,
      port,
      routerPassAccount,
      routerPassPwd,
      remark,
    },
  })
}
// 删除路由
export const deleteRouter = ({ routerId }) => {
  return http.post({
    url: httpApi.bar.deleteRouter,
    data: {
      routerId,
    },
  })
}
// 批量删除路由
export const deleteRouterBatch = ({ barId }) => {
  return http.post({
    url: httpApi.bar.deleteRouterBatch,
    data: {
      barId,
    },
  })
}
// 获取网吧信息
export const getBarInfo = ({ barId }) => {
  return http.usualPost({
    url: httpApi.bar.getBarInfo,
    data: {
      barId,
      isSelf: window.$APP.$route.query.isSelf
        ? window.$APP.$route.query.isSelf
        : 1,
    },
  })
}
// 注册网吧
export const registerBar = ({
  barName,
  barPassword,
  barVerPassword,
  groupId,
  barCityid,
}) => {
  return http.post({
    url: httpApi.bar.registerBar,
    json: {
      barName,
      barPassword,
      barVerPassword,
      groupId,
      barCityid,
    },
  })
}

// 使用远程协助码
export const useAssistBar = ({ assistRemoteKey }) => {
  return http.post({
    url: httpApi.bar.useAssistBar,
    data: {
      assistRemoteKey,
    },
  })
}
//  查询远程协助码
export const getAssistRemoteKey = ({ barId }) => {
  return http.post({
    url: httpApi.bar.getAssistRemoteKey,
    data: {
      barId,
    },
  })
}

//  生成协助码
export const createAssistRemoteKey = ({ barId }) => {
  return http.post({
    url: httpApi.bar.manageAssistRemoteKey,
    data: {
      type: 1,
      barId,
    },
  })
}
//  销毁协助码
export const killAssistRemoteKey = ({ barId }) => {
  return http.post({
    url: httpApi.bar.manageAssistRemoteKey,
    data: {
      type: 2,
      barId,
    },
  })
}
// 获取修改时所需的网吧信息
export const getEditBarInfo = ({ barId }) => {
  return http.usualPost({
    url: httpApi.bar.getEditBarInfo,
    data: {
      barId,
    },
  })
}
// 修改网吧信息
export const updateBarInfo = ({ barName, groupId, barCityid, barId }) => {
  return http.post({
    url: httpApi.bar.updateBarInfo,
    json: {
      barName,
      groupId,
      barCityid,
      barId,
    },
  })
}
// 修改网吧密码
export const changeBarPwd = ({ barId, barPassword, barVerPassword }) => {
  return http.post({
    url: httpApi.bar.changeBarPwd,
    data: {
      barId,
      barPassword,
      barVerPassword,
    },
  })
}
// 改变网吧分组
export const changeBarGroup = ({ barIds, groupId }) => {
  return http.post({
    url: httpApi.bar.changeBarGroup,
    data: {
      barIds,
      groupId,
    },
  })
}
// 删除网吧分组
export const delBarGroup = ({ groupId, toGroupId }) => {
  return http.post({
    url: httpApi.bar.delBarGroup,
    data: {
      groupId,
      toGroupId,
    },
  })
}
// 网吧概况
export const getBarEnv = ({ barId }) => {
  return http.post({
    url: httpApi.bar.getBarEnv,
    data: {
      barId,
    },
  })
}
// 获取云笔记
export const getCloudNote = ({ barId }) => {
  return http.usualPost({
    url: httpApi.bar.getCloudNote,
    data: {
      barId,
    },
  })
}
// 修改云笔记
export const editCloudNote = ({ barId, note }) => {
  return http.post({
    url: httpApi.bar.editCloudNote,
    data: {
      barId,
      note,
    },
  })
}
// 保存分组
export const saveGroupName = ({ groupId, groupName }) => {
  return http.post({
    url: httpApi.bar.saveGroupName,
    data: {
      groupId,
      groupName,
    },
  })
}

export const getReceiveCode = () => {
  return http.post({
    url: httpApi.bar.getReceiveCode,
  })
}

export const getTransferCnt = ({ passportKey, barIds }) => {
  return http.post({
    url: httpApi.bar.getTransferCnt,
    data: {
      passportKey,
      barIds,
    },
  })
}

export const saveReceiveCode = ({ passportKey }) => {
  return http.post({
    url: httpApi.bar.saveReceiveCode,
    data: {
      passportKey,
    },
  })
}
// 获取标签列表
export const getLabelList = () => {
  return http.usualPost({
    url: httpApi.bar.getLabelList,
  })
}
// 修改标签名称
export const editLabelName = ({ labelId, labelName }) => {
  return http.post({
    url: httpApi.bar.editLabelName,
    data: {
      labelId,
      labelName,
    },
  })
}
// 删除标签名称
export const delLabelName = ({ labelId }) => {
  return http.post({
    url: httpApi.bar.delLabelName,
    data: {
      labelId,
    },
  })
}
// 分页获取服务器列表
export const getServerLists = ({
  page,
  pageSize,
  search,
  orderColumn,
  orderType,
}) => {
  return http.usualPost({
    url: httpApi.bar.getServerList,
    data: {
      page,
      pageSize,
      search,
      orderColumn,
      orderType,
    },
  })
}
// 为服务器设置标签
export const setServerLabel = ({ serverList, labelId, search }) => {
  return http.post({
    url: httpApi.bar.setServerLabel,
    json: {
      serverList,
      labelId,
      search,
    },
  })
}
// 删除离线服务器
export const delOfflineBs = ({ barId, bsFlag }) => {
  return http.post({
    url: httpApi.bar.delOfflineBs,
    data: {
      barId,
      bsFlag,
    },
  })
}
